import { render, staticRenderFns } from "./PopupGoto.vue?vue&type=template&id=48efb860&scoped=true&lang=pug&"
import script from "./PopupGoto.vue?vue&type=script&lang=js&"
export * from "./PopupGoto.vue?vue&type=script&lang=js&"
import style0 from "./PopupGoto.vue?vue&type=style&index=0&id=48efb860&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48efb860",
  null
  
)

export default component.exports